import React, { Component } from "react";
import Navbar from "../components/Navbar";
import Header from "../components/Header";
import ItemsList from "../components/ItemsList";
import Footer from "../components/Footer";
import InstructionsSection from "../components/InstructionsSection";
import ConfirmVotePanel from "../components/ConfirmVotePanel";
import Modal from "../components/Modal";
import api from "../api";
import "../styles/Loader.css";

class Home extends Component {
  state = {
    votos_disponibles: 3,
    votes_limit: 3,
    vote_count: 0,
    items: [],
    votos: [],
    modalIsOpen: false,
    email: "",
    errorEmail: false,
    loadingResponse: false,
    errorResponse: false,
    loading: true,
  };

  componentDidMount() {
    const year = new Date().getFullYear();
    this.getMovies(year);
  }

  getMovies = async (year) => {
    var items = await api.movies.list(year);
    this.setState({ items, loading: false });
  };

  addVote = (id) => {
    const votos = [...this.state.votos];
    votos.push(id);
    const vote_count = this.state.vote_count + 1;
    const votos_disponibles = this.state.votos_disponibles - 1;
    this.setState({
      votos,
      vote_count,
      votos_disponibles,
    });
  };

  removeVote = (id) => {
    const votos = [...this.state.votos];
    const index = votos.indexOf(id);
    votos.splice(index, 1);
    const vote_count = this.state.vote_count - 1;
    const votos_disponibles = this.state.votos_disponibles + 1;
    this.setState({
      votos,
      vote_count,
      votos_disponibles,
    });
  };

  handleOpenModal = (e) => {
    this.setState({ modalIsOpen: true });
  };

  handleCloseModal = (e) => {
    this.setState({
      modalIsOpen: false,
      email: "",
      errorEmail: false,
    });
  };

  handleSubmitVotes = async () => {
    this.setState({ loadingResponse: true });
    const data = {
      binVoto: {
        email: this.state.email,
        votos: this.state.votos,
      },
    };
    try {
      const response = await api.votes.send(data);
      this.setState({ loadingResponse: false });
      console.log(response.status);
      if (response.status === 200) this.props.history.push("/confirmacion");
      if (response.status === 400) this.props.history.push("/subcuenta");
      if (response.status === 409) this.props.history.push("/voted");
      if (response.status === 500)
        this.setState({ loadingResponse: false, errorResponse: true });
    } catch (error) {
      this.setState({ loadingResponse: false, errorResponse: true });
      console.log(error);
    }
  };

  handleInputChange = (e) => {
    e.preventDefault();
    this.setState({
      email: e.target.value,
      errorEmail: false,
    });
    if (
      !/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/gm.test(
        e.target.value
      )
    ) {
      this.setState({ errorEmail: true });
    }
  };

  render() {
    return (
      <div>
        <Navbar />
        <Header />
        <InstructionsSection />
        {this.state.loading && (
          <div className="col-lg-12 text-center">
            <div className="lds-ripple">
              <div></div>
              <div></div>
            </div>
            <div className="d-block">Cargando títulos</div>
          </div>
        )}
        <ItemsList
          items={this.state.items}
          addVote={this.addVote}
          removeVote={this.removeVote}
          voteCount={this.state.vote_count}
          votesLimit={this.state.votes_limit}
        />
        <ConfirmVotePanel
          votosDisponibles={this.state.votos_disponibles}
          voteCount={this.state.vote_count}
          onOpenModal={this.handleOpenModal}
        />
        <Footer />
        <Modal
          onCloseModal={this.handleCloseModal}
          modalIsOpen={this.state.modalIsOpen}
          handleSubmitVotes={this.handleSubmitVotes}
          handleInputChange={this.handleInputChange}
          errorEmail={this.state.errorEmail}
          loadingResponse={this.state.loadingResponse}
          errorResponse={this.state.errorResponse}
        />
      </div>
    );
  }
}

export default Home;
